import React from 'react';
import * as Forms from '../../forms/GenerateForms';

export const SelectAchievementType = props => {
    const types = [
            { id: 1, text: 'Press' },
            { id: 2, text: 'Awards' },
            { id: 3, text: 'Publications' },
        ],
        { isOpen, openFormId, setOpenForm, onCancel } = props;

    return (
        isOpen &&
        <div className="achievements-type">
            <ul className="achievements-type__nav">
                { types.map( type =>
                    <li key={type.id}>
                        <button className={`achievements-type__nav__item${ openFormId === type.id ? ' item-active' : ''}`}
                                onClick={ () => setOpenForm( type.id ) }>
                            <span>{type.text}</span>
                        </button>
                    </li>
                )}
            </ul>
            { openFormId === 1 && <Forms.press { ...props } onCancel={ () => onCancel() } />}
            { openFormId === 2 && <Forms.award { ...props } onCancel={ () => onCancel() } /> }
            { openFormId === 3 && <Forms.publication { ...props } onCancel={ () => onCancel() } />}
        </div>
    )
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/achievements/SelectAchievementType.js